import React from 'react';

import {
  useRestrictedActionShowState,
  useRestrictedActionShowActions,
} from './RestrictedActionShowContext';
import { deleteRestrictedAction } from './restApi';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';

import styles from './DeleteRestrictedActionForm.module.scss';

const DeleteRestrictedActionForm = () => {
  const state = useRestrictedActionShowState();
  const { onResponse, onError, updateDeleteConfirmationPhrase, closeDeleteRestrictedActionModal } = useRestrictedActionShowActions();

  const restrictedAction = state?.restrictedAction;
  const expectedPhrase = restrictedAction?.restrictedActionName || '';
  const phraseMatches = state?.deleteConfirmationPhrase === expectedPhrase;

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    deleteRestrictedAction({
      restrictedAction,
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className={styles.warningSection}>
        <h3 className={styles.warningTitle}>Delete Restricted Action</h3>
        <p className={styles.warningText}>
          This action is <strong>permanent and cannot be undone</strong>. Deleting this restricted action will:
        </p>
        <ul className={styles.warningList}>
          <li>Remove all role grants associated with this action</li>
          <li>Remove all direct user grants associated with this action</li>
          <li>Permanently delete the restricted action record</li>
        </ul>
        <p className={styles.preservedText}>
          Users, roles, and other restricted actions will <strong>not</strong> be affected.
        </p>
      </div>

      <Field
        label={`Type "${expectedPhrase}" to confirm`}
        id="delete_restricted_action_confirmation_phrase"
      >
        <Input
          type="text"
          value={state?.deleteConfirmationPhrase || ''}
          onChange={(e) => updateDeleteConfirmationPhrase(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeDeleteRestrictedActionModal()}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="destructive"
            disabled={!phraseMatches}
          >
            Delete Permanently
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default DeleteRestrictedActionForm;
